{
  "labels": {
    "new_organization": "Neue Organisation"
  },
  "input_labels": {
    "name": "Name",
    "description": "Beschreibung",
    "company_name": "Unternehmensname",
    "email": "E-Mail",
    "language": "Sprache",
    "line1": "Adresszeile 1",
    "line2": "Adresszeile 2",
    "line3": "Adresszeile 3",
    "city": "Ort",
    "state": "Bundesland",
    "country_code": "Land",
    "postal_code": "PLZ",
    "vat_number": "UID"
  },
  "input_hints": {
    "name": "Der Anzeigename Ihrer Organisation",
    "description": "Eine kurze Zusammenfassung darüber, was Ihre Organisation macht",
    "company_name": "Der gesetzlich eingetragene Name bei Ihrer lokalen Behörde",
    "email": "Hierhin senden wir Benachrichtigungen und Updates",
    "language": "Die Sprache für E-Mails",
    "vat_number": "Erforderlich für EU-Unternehmen zur Rechnungsstellung"
  },
  "input_groups": {
    "info": "Organisationsinformationen",
    "contact": "Kontakt",
    "tax_info": "Steuerinformationen",
    "location": "Standort"
  },
  "templates": {},
  "validation": {
    "name": {
      "empty": "Geben Sie den Namen der Organisation ein",
      "min_length": "Der Name darf nicht kürzer als {{minLength}} Zeichen sein",
      "max_length": "Der Name darf nicht länger als {{maxLength}} Zeichen sein",
      "invalid": "Der Name muss mit einem Buchstaben beginnen und mit einem Buchstaben oder einer Ziffer enden. Er darf Leerzeichen, Punkte und Bindestriche enthalten."
    },
    "companyName": {
      "empty": "Geben Sie den Unternehmensnamen ein"
    },
    "description": {
      "max_length": "Die Beschreibung darf nicht länger als 200 Zeichen sein"
    },
    "email": {
      "invalid_email": "Geben Sie eine gültige E-Mail Adresse ein"
    },
    "language": {
      "empty": "Wählen Sie eine Sprache aus.."
    },
    "address": {
      "line1": {
        "empty": "Geben Sie die Adresszeile 1 ein"
      },
      "line2": {
        "empty": "Address Line 2 is required"
      },
      "line3": {
        "empty": "Address Line 3 is required"
      },
      "postalCode": {
        "empty": "Geben Sie eine PLZ ein"
      },
      "city": {
        "empty": "Geben Sie einen Ort ein"
      },
      "countryCode": {
        "empty": "Wählen Sie ein Land aus..",
        "not_positive": "$t(empty)"
      }
    }
  },
  "buttons": {
    "previous": "Zurück",
    "next": "Weiter",
    "create": "Erstellen"
  }
}
